import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
  ButtonWhite,
} from "../../Reusablecomponents/UIButtons";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import { CloseOutlined, EyeOutlined, LeftOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  message,
  Row,
  Tabs,
  Input,
  Tooltip,
  Select,
  Form,
  Upload,
  Modal,
  InputNumber,
  DatePicker,
  Spin,
  Dropdown,
  Menu,
  Card,
} from "antd";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as Swap } from "../../assets/images/swap-alt-svgrepo-com.svg";
import { ReactComponent as MStart } from "../../assets/images/MStart.svg";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as DownloadIcon } from "../../assets/images/download1.svg";
import { ReactComponent as UpdateCompleted } from "../../assets/images/update-complete.svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import { CALL_API } from "../../Common/api";
import MapComponent from "../../Reusablecomponents/MapComponent";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  AttechmentType,
  chargetype,
  AITripStatusEnum,
  AIConsignmentCollectionEvents,
  AIConsignmentDeliveryEvents,
  DispatchType,
  shipmentType,
  FinishType,
} from "../../Common/constant";
import ChatComponent from "../../Reusablecomponents/Comment/ChatComponent";
import FilesTable from "../../Reusablecomponents/FilesTable";
import { ReactComponent as MapIcon } from "../../assets/images/Group 1000004561.svg";
import { ReactComponent as Aideleteicon } from "../../assets/livetracking/Aideleteicon.svg";
import { Navigate, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";

dayjs.extend(advancedFormat);
const { Option } = Select;
const WrapperBox = styled.div`
  .container_five {
    margin-top: 20px;
  }
  .containerfour {
  }
  .div_container {
    background-color: #f8f8f8;
    padding: 7px 7px 7px 7px;
    border-radius: 12px;
    margin-bottom: 10px;
  }
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .status {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .consignor_code > label {
    color: #5f6d8c;
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 18px !important;
  }
  p {
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    color: black;
  }
  .green-dot {
    width: 4px;
    height: 4px;
    background-color: #2c963d;
    border-radius: 50%;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: end;
    }

    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }

  @media (max-width: 320px) {
    .tabsectionfor_table {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  .consingment_container_record {
    display: flex;
    flex-direction: column;
    gap: 19px;
    text-align: justify;
  }
  p {
    margin-bottom: 0px;
     line-height: normal;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }

  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    padding: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: transparent;
    background-color: transparent;
  }
  .Create_btn_edit:hover {
    background-color: transparent;
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code_container {
    width: 100%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
  }
  .Add_btn {
    border: none;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td > * {
    margin-left: 12px;
  }

  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 7px 7px 5px;
    margin-bottom: 19px;
    border-bottom: 1px solid rgb(231 231, 237);
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }

  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
    margin-top: 20px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
  .bulk_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: #e8ffec !important;
    color: #2c963d !important;
  }
  .update_complete_btn {
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgba(255, 230, 167, 0.4) !important;
    color: rgba(194, 142, 8, 1) !important;
  }
  .inactive-status {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #f20000;
  }

  .red-dot {
    width: 4px;
    height: 4px;
    background-color: #f20000;
    border-radius: 50%;
  }
  .modal_popup {
    display: flex;
    padding: 14px 0px 29px 0px;
    align-items: center;
  }
  .apiintegration_names {
    margin: 4px 4px 4px 10px;
  }
  .selectedVehicle {
    font-size: 16px;
    font-weight: 400;
    color: #576d8c;
  }
`;

const TripDetailsAI = ({
  setConsignee,
  AddEditFormm,
  handleChange,
  handleSubmitForm,
  handleClose,
  drawerOpen,
  setDrawerOpen,
  record,
  tripId,
  fetchTripListData,
  ShipmentId,
  vehId,
  selectededittwo,
}) => {
  const navigate = useNavigate();
  const userListx = useSelector((state) => state?.authTracking?.userList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const vehicleLists = useSelector((state) => state?.authTracking?.vehicleList);
  const driverWithVehicles = useSelector(
    (state) => state?.authTracking?.driverWithVehicle,
  );
  const [form] = Form.useForm();
  const [activekey, setactivekey] = useState("1");
  const [hoveredrow, setHoveredrow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [singleTrip, setSingleTrip] = useState({});
  const [locationData, setLocationData] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(singleTrip?.RegNo);
  const [consignmentList, setConsignmentList] = useState([]);
  const [mapList, setMapList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [breakList, setBreakList] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [deleteloading, setDeleteLoading] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [isEventEdit, setIsEventEdit] = useState(false);
  const [isModalOpeN, setIsModalOpeN] = useState(false);
  const [eventData, setEventData] = useState({});
  const [isLocationPickerVisible, setIsLocationPickerVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapCoords, setMapCoords] = useState({ lat: null, lng: null });
  const [getsingletripstat, setGetsingletripstat] = useState(null);
  const [getsingletripid, setGetsingletripbyid] = useState(null);
  const [unassignedconsignee, setunassignedconsignee] = useState(null);
  const [startEndLoc, setStartEndloc] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("TRIPAI", "ET"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("TRIP", "DT"),
    [reduxPermissions],
  );
  // const statusAllowed = useMemo(
  //   () => hasPermission("TRIPAI", "CS"),
  //   [reduxPermissions],
  // );
  const manTripAllowed = useMemo(
    () => hasPermission("TRIPAI", "MS"),
    [reduxPermissions],
  );
  // const consView = useMemo(
  //   () => hasPermission("TRIPAI", "CVE"),
  //   [reduxPermissions],
  // );
  // const consDelete = useMemo(
  //   () => hasPermission("TRIPAI", "CD"),
  //   [reduxPermissions],
  // );
  // const uplFilesAllowed = useMemo(
  //   () => hasPermission("TRIPAI", "UF"),
  //   [reduxPermissions],
  // );

  const formatMinutesToHHMM = (minutes) => {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };
  const handleChangeselect = (value) => {
    setSelectedVehicle(value);
  };
  const [CustomData, setCustomData] = useState([]);

  const timeFormat = (time, ...arg) => {
    const minutes = time ? time : 0;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const formatted = `${String(hours).padStart(2, "0")}:${String(
      mins,
    ).padStart(2, "0")}`;
    return formatted;
  };
  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Trip",
        RefId: tripId,
        Active: 1,
        McId: userInfo?.MCID,
      });
      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };

  useEffect(() => {
    if (singleTrip?.RegNo) {
      setSelectedVehicle(singleTrip.RegNo);
    }
  }, [singleTrip]);
  const getlocation = async () => {
    setLoading(true);
    //const { data } = await CALL_API("GET", `ai/trackingLink/getEventdetailsAi?aTripId=${tripId}
    const { data } = await CALL_API(
      "GET",
      `ai/trackingLink/getEventdetailsAi?aTripId=${tripId}&ShipmentType=${ShipmentId}&aVehid=${vehId}&mcId=${userInfo?.MCID}
`,
    );

    setLocationData(data);
    setLoading(false);
  };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location); // Update the state with the selected location
    form.setFieldsValue({ location: location?.place_name }); // Update the form field
    setIsLocationPickerVisible(false); // Close the LocationPicker modal
  };
  const [formData, setFormData] = useState({
    consignor: "",
    transporter: "",
    consignee: "",
    chargetype: "",
    priority: "",
    noofdeliverables: "",
    dimension: "",
    gross: "",
    switch: "",
    plocation: "",
    pdate: "",
    dlocation: "",
    ddate: "",
    pnotes: "",
    dnotes: "",
    remark: "",
    linkdossier: "",
    orderno: "",
    referenceno: "",
    containerno: "",
    zone: "",
  });
  const MAPBOX_TOKEN =
    "pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow";

  const [data, setData] = useState([]);

  const [route, setRoute] = useState(null);

  useEffect(() => {
    if (mapList?.length > 0) {
      const getRoute = async () => {
        const start = `${data[0]?.StartLng},${data[0]?.StartLat}`;
        const end = `${data[0]?.EndLng},${data[0]?.EndLat}`;
        const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${start};${end}?geometries=geojson&access_token=${MAPBOX_TOKEN}`;

        const response = await fetch(url);
        const json = await response?.json();
        setRoute(json.routes[0]?.geometry || null);
      };

      getRoute();
    }
  }, []);

  // Open handlers for both modals
  const handlevehiclechangeopen = () => setModalType("vehiclechange");
  const handleudoUpdateOpen = () => setModalType("udoUpdate");

  // Common close handler
  const handleModalClose = () => setModalType(null);
  const [isEditing, setIsEditing] = useState(false);
  const showDrawer = () => {
    setIsEditing(false);
    setFormData({
      consignor: "",
      transporter: "",
      consignee: "",
      chargetype: "",
      priority: "",
      noofdeliverables: "",
      dimension: "",
      gross: "",
      switch: "",
      plocation: "",
      pdate: "",
      dlocation: "",
      ddate: "",
      pnotes: "",
      dnotes: "",
      remark: "",
      linkdossier: "",
      orderno: "",
      referenceno: "",
      containerno: "",
      zone: "",
    });
    setDrawerOpen(true);
  };

  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
  };
  const getSingleConsinment = async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `aitrip/getconsignByTripId?tripId=${tripId}`,
      );
      if (data && Array.isArray(data)) {
        const startEndLocs = data.flatMap((consign) => {
          const points = [];

          const startLat = parseFloat(consign.StartLat);
          const startLng = parseFloat(consign.StartLng);
          const endLat = parseFloat(consign.EndLat);
          const endLng = parseFloat(consign.EndLng);

          // Validate: not NaN, not 0, and lat/lng not identical
          if (
            !isNaN(startLat) &&
            !isNaN(startLng) &&
            (startLat !== 0 || startLng !== 0) &&
            startLat !== startLng
          ) {
            points.push({ lat: startLat, lng: startLng });
          }

          if (
            !isNaN(endLat) &&
            !isNaN(endLng) &&
            (endLat !== 0 || endLng !== 0) &&
            endLat !== endLng
          ) {
            points.push({ lat: endLat, lng: endLng });
          }

          return points;
        });
        setStartEndloc(startEndLocs);
      }
    } catch (error) {
      console.error("Error fetching consignments:", error);
    }
  };

  //http://127.0.0.1:3000/ai/trip/getSingleAITripById
  const getSingletripData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `ai/trip/getSingleAITripById`, {
        tripId: tripId,
        shipmentTypeId: ShipmentId,
      });
      setSingleTrip(data);
    } catch (error) {
      console.error("Error fetching trip list data:", error);
      message.error("Failed to fetch trip list data.");
    } finally {
      setLoading(false); // Stop the spinner only after data is processed
    }
  };

  const getConsignmentData = async () => {
    setLoading(true);
    const { data } = await CALL_API(
      "GET",
      `aitrip/getconsignByTripId?tripId=${tripId}`,
    );
    setConsignmentList(data);
    setLoading(false);
  };

  const getMapData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `ai/trip/getMapByTripId`, {
      tripId: tripId,
    });
    setMapList(
      data?.map((item) => {
        return { lat: item?.StartLat, long: item?.StartLng };
      }),
    );
    setData(data);
    setLoading(false);
  };

  // const getEventData = async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API("POST", `aitrip/getEventByTripId`, {
  //       tripId: tripId,
  //     });
  //     setEventList(data);
  //   } catch (error) {
  //     console.error("Error fetching event data:", error);
  //     message.error("Failed to fetch event data. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //   const getEventData = async () => {
  //     try {
  //       setLoading(true);
  //       const res = await CALL_API("POST", `aitrip/getEventByTripId`, {
  //         tripId: tripId,
  //       });

  //       const eventData = res.data || [];
  //       setEventList(eventData);

  //       // Option 1: Get the first valid LAT/LNG
  //       const location = eventData.find((item) => item.LAT && item.LNG);

  // if (location) {
  //   setMapCoords([
  //     {
  //       Lat: location.LAT,
  //       Lng: location.LNG,
  //     },
  //   ]);
  // }
  //     } catch (err) {
  //       console.error(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const getEventData = async () => {
    try {
      setLoading(true);
      const res = await CALL_API("POST", `aitrip/getEventByTripId`, {
        tripId: tripId,
      });

      const eventData = res.data || [];
      setEventList(eventData);

      // Filter only valid LAT/LNG entries
      const validLocations = eventData
        .filter(
          (item) =>
            item.LAT !== null &&
            item.LAT !== undefined &&
            item.LNG !== null &&
            item.LNG !== undefined,
        )
        .map((item) => ({
          Lat: Number(item.LAT),
          Lng: Number(item.LNG),
        }));

      if (validLocations.length > 0) {
        setMapCoords(validLocations); // store all valid coords
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // const getEventData = async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API("POST", `aitrip/getEventByTripId`, {
  //       tripId: tripId,
  //     });
  //     setEventList(data);
  //   } catch (error) {
  //     console.error("Error fetching event data:", error);
  //     message.error("Failed to fetch event data. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getBreakData = async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `trip/driverBreaksByTripId`, {
        tripId: tripId,
      });
      setBreakList(data);
    } catch (error) {
      console.error("Error fetching break data:", error);
      message.error("Failed to fetch break data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const handleupdateee = () => {};

  const getFileData = async () => {
    const ConsignId = singleTrip?.Consignments?.[0]?.ConsignmentId;
    setLoading(true);

    const responses = await Promise.all([
      CALL_API("POST", `trip/getFileTab`, { refTab: "AITRIP", refId: tripId }),
      CALL_API("POST", `trip/getFileTab`, {
        refTab: "AICONSIGN",
        refId: ConsignId,
      }),
    ]);

    const allFiles = [
      ...(responses[0]?.data || []),
      ...(responses[1]?.data || []),
    ];
    setFilesList(allFiles);
    setLoading(false);
  };
  //Remove consign from trip & consgnment converted unassigned consignment
  const removeconsign = async (id) => {
    setLoading(true);
    const { data } = await CALL_API(
      "get",
      `ai/trip/removeConsignFromTrip?consignId=${id}`,
    );

    setunassignedconsignee(false);
    getConsignmentData();
    setLoading(false);
    message.success("Consignment Deleted Successfully");
    setIsDeleteModalVisible1(false);
    setDeleteId1(null);
    setactivekey("1");
    fetchTripListData(); // Refresh the trip list in parent

    setConsignee(false);
  };

  const startManualTrip = async (id, TRIPID) => {
    setLoading(true);
    const { ResponseCode, message: Message } = await CALL_API(
      "POST",
      `ai/startTripManually`,
      {
        FAssetID: id,
        TripId: TRIPID,
        FType: singleTrip?.STATUS === 3 ? "END" : "START",
      },
    );
    setLoading(false);
    if (ResponseCode === 200) {
      message.success(Message);
      getSingletripData();
    } else {
      message.warning(Message);
    }
    setIsManualModalVisible(false);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
  };

  const getCommentData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getcommentTab`, {
      refTab: "TRIP",
      refId: tripId,
    });
    setCommentsList(data);
    setLoading(false);
  };
  useEffect(() => {
    getcustomedatabyRefId();
    getSingletripData();
  }, []);

  useEffect(() => {
    if (activekey === "1") {
      getConsignmentData();
    } else if (activekey === "2") {
      getMapData();
      getlocation();
      getSingleConsinment();
    } else if (activekey === "3") {
      getEventData();
    } else if (activekey === "4") {
      getFileData();
    } else if (activekey === "5") {
      getCommentData();
    } else if (activekey === "6") {
      getBreakData();
    }
  }, [activekey]);
  const [isManualModalVisible, setIsManualModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isDeleteModalVisible1, setIsDeleteModalVisible1] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete
  const [deleteId1, setDeleteId1] = useState(null); // To store the ID of the consignment to delete

  const columns1 = [
    {
      title: "Consign Code",
      dataIndex: "Code",
      key: "Code",
    },

    {
      title: "Event",
      dataIndex: "LastModify",
      key: "LastModify",
      render: (text, record) => {
        const isCollection = record.ShipmentType === 2;
        const EventType = isCollection
          ? AIConsignmentCollectionEvents
          : AIConsignmentDeliveryEvents;
        const event = EventType.find((item) => item.value === text);
        return event?.name || `Unknown (${text})`;
      },
    },

    {
      title: "Consignor",
      dataIndex: "CustName",
      key: "CustName",
    },
    {
      title: "Consignee",
      dataIndex: "FNAME",
      key: "FNAME",
    },
    {
      title: "Location",
      dataIndex: "StartLocation",
      key: "StartLocation",
      render: (text, render) => {
        return (
          <div>
            {render?.StartLocation}
            <br></br>
            {render?.EndLocation}
          </div>
        );
      },
    },
    {
      title: "Transporter",
      dataIndex: "SupName",
      key: "SupName",
    },
    {
      title: "Actions",
      key: "actions",
      width: "35%",
      render: (_, record) => (
        // <div
        //   className={
        //     hoveredrow === record.key ? "d-flex gap-5 opacity-100" : "opacity-0"
        //   }
        // >

        <div
          className="d-flex gap-5"
          style={{
            opacity: hoveredrow === record.key ? 1 : "",
            transition: "opacity 0.3s ease",
          }}
        >
          {/* <Tooltip title={!consView ? "No permission" : ""}> */}
          <EyeOutlined
            style={{
              // cursor: consView ? "pointer" : "not-allowed",
              cursor: "pointer",
              paddingRight: "10px",
              fontSize: "17px",
            }}
            onClick={(e) => {
              // if (!consView) return;
              e.stopPropagation();
              // editUser(record);
              navigate(`/ConsignmentAI`, {
                state: {
                  consignmentRecord: record,
                  fromAITripPage: true,
                  tripId: tripId,
                  vehId: vehId,
                  ShipmentId: ShipmentId,
                },
              });
            }}
          />
          {/* </Tooltip> */}
          {/* <Tooltip title={!consDelete ? "No permission" : ""}> */}
          <DeleteIcon
            style={{
              // cursor: consDelete ? "pointer" : "not-allowed",
              cursor: "pointer",
            }}
            onClick={(e) => {
              // if (!consDelete) return;
              e.stopPropagation();
              setDeleteId1(record?.ConsignId); // Set the ID of the consignment to delete
              setIsDeleteModalVisible1(true); // Show the delete confirmation modal
            }}
          />
          {/* </Tooltip> */}
        </div>
      ),
    },
  ];

  const filteredEventList = eventList.filter((item) =>
    [0, 3, 4].includes(item.EVTYPE),
  );
  const columns3 = [
    {
      title: "Event",
      dataIndex: "EVTYPE",
      key: "EVTYPE",
      render: (text, record) => {
        const matchedEvent = AITripStatusEnum?.find(
          (item) => item?.value === text,
        );

        // Render only for values 1, 3, and 4
        if (![0, 3, 4].includes(text)) {
          return null; // Return nothing for other values
        }

        return (
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <MapIcon
              onClick={handlemapicon}
              style={{ width: "14px", height: "14px" }}
            />
            {matchedEvent?.label || "---"}
          </span>
        );
      },
    },
    {
      title: "Updated on",
      dataIndex: "MODON",
      key: "MODON",
      render: (text) => {
        return text
          ? moment(text).subtract(3, "hours").format("Do MMM YYYY; hh:mm A")
          : "---";
      },
    },
    {
      title: "Updated by",
      dataIndex: "MODBY",
      key: "MODBY",
      render: (text) => {
        if (!text) return <span style={{ opacity: 0.6 }}>---</span>;

        const uid = Number(text); // Ensure numeric comparison

        // Flatten user list if paginated (check your structure)
        const users = Array.isArray(userListx?.data)
          ? userListx.data
          : Array.isArray(userListx)
            ? userListx
            : [];

        const user = users.find((item) => Number(item.UID) === uid);

        return user ? (
          user.FULLNM || `${user.FIRSTNM} ${user.LASTNM}`
        ) : (
          <span style={{ opacity: 0.6 }}>---</span>
        );
      },
    },

    {
      title: "",
      dataIndex: "",
      key: "",
      width: "10%",
      render: (_, record) => {
        const evtype = record?.EVTYPE;
        return (
          <>
            <div
              className={
                hoveredrow === record.key
                  ? "d-flex gap-3 opacity-100"
                  : "opacity-1"
              }
            >
              {/* <EditIcon
              onClick={() => {
                setIsEventEdit(true);
                setEventData(record);
                setIsModalOpeN(true);
              }}
              style={{ cursor: "pointer" }}
            />  */}
            </div>
          </>
        );
      },
    },
  ];

  const getFieldsForEvent = (evtype) => {
    if (evtype === 1 || evtype === 11) {
      return ["odo", "datetime", "location"];
    } else if ([2, 3, 4, 5, 6, 7, 8, 9, 10].includes(evtype)) {
      return ["datetime", "location"];
    }
    return [];
  };

  const columns6 = [
    {
      title: "Break Type",
      dataIndex: "breaktype",
      key: "breaktype",
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "Started",
      dataIndex: "started",
      key: "started",
    },
    {
      title: "Ended",
      dataIndex: "ended",
      key: "ended",
    },
  ];

  const ChatTableView = ({ record }) => {
    return (
      <div>
        <p>Chat Component for: {record.comments}</p>
        {/* Your actual chat UI here */}
      </div>
    );
  };

  const handlemouseenter = (key) => {
    setHoveredrow(key);
  };

  const handlemouseleave = () => {
    setHoveredrow(null);
  };
  const handlechange = (key) => {
    setactivekey(key);
  };

  const handleClickme = () => {
    setConsignee(false);
  };
  const handleeditclick = () => {
    setDrawerOpen(true);
  };

  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const TripEditForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [[6, 6, 6], [6], [6, 6]],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Trip Type</span>,
              type: "select",
              name: "triptype",
              placeholder: "Local",
              value: formData.triptype,
              onChange: handleChange,
              maxLength: 50,
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>ODO Start</span>,
              type: "select",
              name: "odostart",
              placeholder: "167",
              value: formData.odostart,
              onChange: handleChange,
              maxLength: 50,
            },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>ODO End</span>,
              type: "text",
              name: "odoend",
              placeholder: "198",
              value: formData.odoend,
              onChange: handleChange,
              maxLength: 50,
            },
          ],
          [
            {
              id: 4,
              label: <span style={{ color: "#5F6D8C" }}>Remark</span>,
              type: "text",
              name: "remark",
              placeholder: "24th Aug 2024 - 24th Sep 2024",
              value: formData.remark,
              onChange: handleChange,
              maxLength: 50,
            },
          ],
          [
            {
              id: 5,
              label: <span style={{ color: "#5F6D8C" }}>Fuel Quantity</span>,
              type: "text",
              name: "fuelquantity",
              placeholder: "0",
              value: formData.fuelquantity,
              onChange: handleChange,
              maxLength: 50,
            },
            {
              id: 6,
              label: <span style={{ color: "#5F6D8C" }}>Trip Allowance</span>,
              type: "text",
              name: "tripallowance",
              placeholder: "0",
              value: formData.tripallowance,
              onChange: handleChange,
              maxLength: 50,
            },
            {},
            {},
          ],
        ],
      },
    ],
  };

  const closeEditModal = () => {
    handlevehiclechangeopen(false);
  };

  const [vehiclebreak, setVehiclebreak] = useState([]);

  const vehic = driverWithVehicles?.filter(
    (v) => v?.REGNO === selectedVehicle,
  )?.[0]?.VEHID;
  // const editModuleupdate = () => {
  //   const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  //   handlevehiclechangeopen(true);
  //   const { data } = CALL_API("POST", `VehicleReplacement`, {
  //     TripId: singleTrip?.TRIPID,
  //     VehId: vehic,
  //     UID: userInfo?.UID,
  //   });
  //   setVehiclebreak(data?.data);
  //   setModalType(null);
  //   await delay(1000);
  //   await fetchTripListData();

  // };
  const handleclickdeleteAi = async (tripId) => {
    setDeleteLoading(true);

    try {
      const { ResponseCode } = await CALL_API(
        "DELETE",
        `ai/trip/deleteTrip/${tripId}`,
      );

      if (ResponseCode === 200) {
        await fetchTripListData();
        setConsignee(false);
        setIsDeleteModalVisible(false);
        setDeleteId(null);
        message.success("Trip Deleted Successfully");
      }
    } finally {
      setDeleteLoading(false);
    }
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const editModuleupdate = async () => {
    handlevehiclechangeopen(true);

    try {
      const { data } = await CALL_API("POST", `ai/VehicleReplacement`, {
        TripId: singleTrip?.TRIPID,
        VehId: vehic,
        UID: userInfo?.UID,
      });

      setVehiclebreak(data?.data);
      setModalType(null);

      await delay(1500);

      await fetchTripListData();
      await getSingletripData();
    } catch (err) {
      console.error("Error in editModuleupdate:", err);
    }
  };
  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };

  const user = { UID: userInfo?.UID }; // Example logged-in user
  const [mapicon, setMapicon] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handlemapicon = () => {
    setIsModalOpen(true);
  };

  const handleClosecontainer = () => {
    setIsModalOpen(false);
  };

  const [dropdownselectchange, setDropdownselectchange] = useState("1");
  const handledropdownchange = (event) => {
    setDropdownselectchange(event.key);
  };
  const statusMap = {
    0: { label: "Assigned", color: "#E4A400" },
    1: { label: "Accepted", color: "#1890ff" },
    2: { label: "Rejected", color: "#ff4d4f" },
    3: { label: "In Progress", color: "#E4A400" },
    4: { label: "Completed", color: "#2C963D" },
    5: { label: "Reassigned", color: "#722ed1" },
  };
  const menu = (
    <Menu>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="1"
      >
        Consignment
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="2"
      >
        Map
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="3"
      >
        Event
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="4"
      >
        Files
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="5"
      >
        Comment
      </Menu.Item>
      <Menu.Item
        onClick={(e) => {
          handledropdownchange(e);
        }}
        key="6"
      >
        Driver Break
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <UIModal
        className="modal_updatable"
        width={500}
        open={isManualModalVisible}
        onClose={() => {
          setIsManualModalVisible(false);
          // setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <center>
            {singleTrip?.STATUS === 3 ? (
              <Card
                style={{
                  backgroundColor: "rgba(255, 245, 220, 1)",
                  width: "fit-content",
                  display: "inline-block",
                  borderRadius: "999px", // or "50%" if you really want circle
                }}
                bodyStyle={{
                  padding: "12px",
                }}
              >
                <UpdateCompleted />
              </Card>
            ) : (
              <MStart />
            )}
          </center>
          <br />
          <h4>
            {singleTrip?.STATUS === 3 ? "Complete" : "Start"} Trip Manually
          </h4>
          <br />
          <p style={{ color: "#5F6D8C" }}>
            Are you sure you want to{" "}
            {singleTrip?.STATUS === 3 ? "complete" : "start"} this trip
            manually?
          </p>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <Buttontransparent
              onClick={() => {
                setIsManualModalVisible(false); // Close the modal
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              loading={loading}
              onClick={() => {
                startManualTrip(singleTrip?.DeviceName, singleTrip?.TRIPID);
              }}
            >
              Confirm
            </ButtonFilled>
          </div>
        </div>
      </UIModal>
      <UIModal
        className="modal_updatable"
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
          setDeleteId(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this Trip?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              loading={deleteloading}
              onClick={() => {
                handleclickdeleteAi(tripId); // Call the delete function with the selected ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                setDeleteId(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        open={isDeleteModalVisible1}
        onClose={() => {
          setIsDeleteModalVisible1(false);
          setDeleteId1(null); // Reset the delete ID
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this consignment?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                removeconsign(deleteId1); // Call the delete function with the selected ID
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible1(false); // Close the modal
                setDeleteId1(null); // Reset the delete ID
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>
      <UIModal
        width={500}
        height={500} // equal height to width
        open={isModalOpen}
        onClose={handleClosecontainer}
        closeButton={false}
      >
        {mapCoords?.length > 0 ? (
          <div style={{ width: "500px", height: "500px" }}>
            <MapComponent locationsTL={mapCoords} isminimap={true} />
          </div>
        ) : (
          <div>No location available</div>
        )}
      </UIModal>

      <UIModal
        width={600}
        open={modalType !== null} // Open if any modal type is set
        onClose={handleModalClose}
        closeButton={false}
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <h5 className="flilter_five">
                    {/* {modalType === "vehiclechange"
                      ? "Trip 27632 - Changing Vehicle"
                      : "Updating ODO Reading"} */}
                  </h5>
                  <p className="apiintegration_names">
                    {selectedVehicle} &nbsp;{" "}
                    {
                      driverWithVehicles?.filter(
                        (v) => v?.REGNO === selectedVehicle,
                      )?.[0]?.DriverName
                    }
                  </p>
                </div>
                <hr />
              </Col>

              {modalType === "vehiclechange" && (
                <Col xl={24} sm={24} style={{ marginBottom: "16px" }}>
                  <div className="modal_popup">
                    <div>
                      <p className="selectedVehicle">Current Vehicle </p>
                    </div>
                    <div>
                      <p className="apiintegration_names">
                        {selectedVehicle}{" "}
                        {
                          driverWithVehicles?.filter(
                            (v) => v?.REGNO === selectedVehicle,
                          )?.[0]?.DriverName
                        }
                      </p>
                    </div>
                  </div>

                  <div>
                    <label className="selectedVehicle">
                      Choose a new vehicle to change
                    </label>

                    <Select
                      allowClear
                      style={{ width: "100%" }}
                      onChange={handleChangeselect}
                    >
                      {Array.isArray(driverWithVehicles) &&
                        driverWithVehicles.map((vehicle) => (
                          <Option key={vehicle.REGNO} value={vehicle.REGNO}>
                            {vehicle.REGNO} - {vehicle.DriverName}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </Col>
              )}

              {modalType === "udoUpdate" && (
                <Col xl={24} sm={24}>
                  <p>ODO Reading</p>
                </Col>
              )}
            </Row>
          </WrapperBox>
        }
        footer={[
          <WrapperBox key="footer">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <ButtonFilled
                onClick={handleModalClose}
                className="cancel_btn_forpopup_two"
              >
                Cancel
              </ButtonFilled>
              <ButtonFilled onClick={editModuleupdate}>
                {modalType === "resolve" ? "Resolve" : "Update"}
              </ButtonFilled>
            </div>
          </WrapperBox>,
        ]}
      />
      <WrapperBox>
        <Row gutter={16}>
          {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
            <Col xs={24} xl={24}>
              <div className="consingment_container">
                <div className="consingment_container_two">
                  <ButtonOutlined
                    onClick={handleClickme}
                    className="Create_btn"
                  >
                    <LeftOutlined className="left_outlined_icon" />
                  </ButtonOutlined>
                  <p>Trip Code - {singleTrip?.CODE}</p>
                </div>
                <div className="consingment_container_two  consingment_container_formbresponsive">
                  <EditIcon
                    style={{
                      cursor: updateAllowed ? "pointer" : "not-allowed",
                    }}
                    onClick={() => {
                      if (!updateAllowed) return;
                      editUser(selectededittwo);
                    }}
                  />
                  <Aideleteicon
                    style={{
                      cursor: deleteAllowed ? "pointer" : "not-allowed",
                      marginLeft: "10px",
                    }}
                    onClick={(e) => {
                      if (!deleteAllowed) return;
                      e.stopPropagation();
                      setDeleteId(record?.TRIPID); // Set the ID of the consignment to delete
                      setIsDeleteModalVisible(true); // Show the delete confirmation modal
                    }}
                  />
                </div>
              </div>
            </Col>
          ) : (
            <Col xs={24} xl={24}>
              <div className="consingment_container">
                <div className="consingment_container_two">
                  <ButtonOutlined
                    onClick={handleClickme}
                    className="Create_btn"
                  >
                    <LeftOutlined className="left_outlined_icon" />
                  </ButtonOutlined>
                  <p>
                    Trip Code - {singleTrip?.CODE || ""} (
                    {singleTrip?.CrOn
                      ? dayjs(singleTrip.CrOn).format("Do MMM YYYY")
                      : "---"}
                    )
                  </p>
                </div>
                <div className="consingment_container_two  consingment_container_formbresponsive">
                  {/* <div className="consignor_code">
                    <p>Status</p>
                  </div> */}
                  {/* <Tooltip title={!statusAllowed ? "No permission" : ""}> */}
                  {/* <Select
                      // disabled={!statusAllowed}
                      value={
                        singleTrip?.STATUS === 0
                          ? "Assigned"
                          : singleTrip?.STATUS === 1
                            ? "Accepted"
                            : singleTrip?.STATUS === 2
                              ? "Rejected"
                              : singleTrip?.STATUS === 3
                                ? "In Progress"
                                : singleTrip?.STATUS === 4
                                  ? "Completed"
                                  : singleTrip?.STATUS === 5
                                    ? "Reassigned"
                                    : ""
                      }
                      style={{
                        width: "193px",
                        marginRight: "8px",
                        marginLeft: "-30px",
                      }}
                      onChange={async (value) => {
                        // Map the selected value to the corresponding status code
                        const statusCode = value;

                        try {
                          setLoading(true); // Start the spinner

                          // Call the API to update the trip status
                          const { data } = await CALL_API(
                            "POST",
                            `ai/trip/updateTripStatus`,
                            {
                              TripId: singleTrip?.TRIPID, // Use the TripId from the singleTrip object
                              Status: statusCode,
                              Lat: null, // Replace with actual latitude if available
                              Lng: null, // Replace with actual longitude if available
                            },
                          );

                          message.success("Trip status updated successfully!"); // Show success message

                          // Update the singleTrip state to reflect the new status
                          setSingleTrip((prev) => ({
                            ...prev,
                            STATUS: statusCode,
                          }));
                        } catch (error) {
                          console.error("Error updating trip status:", error);
                          message.error(
                            "Failed to update trip status. Please try again.",
                          );
                        } finally {
                          setLoading(false); // Stop the spinner
                        }
                      }}
                    >
                    </Select> */}
                  {/* </Tooltip> */}

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <span style={{ color: "#5F6D8C", fontSize: "16px" }}>
                      Status
                    </span>

                    <span
                      style={{
                        color: statusMap[singleTrip?.STATUS]?.color || "#000",
                        fontWeight: 500,
                        fontSize: "16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span
                        style={{
                          width: "8px",
                          height: "8px",
                          borderRadius: "50%",
                          backgroundColor: statusMap[singleTrip?.STATUS]?.color,
                          display: "inline-block",
                        }}
                      />
                      {statusMap[singleTrip?.STATUS]?.label || "-"}
                    </span>
                  </div>
                  {[0, 1].includes(singleTrip?.STATUS) && (
                    <Tooltip title={!manTripAllowed ? "No permission" : ""}>
                      <ButtonOutlined
                        className="bulk_btn"
                        style={{
                          cursor: manTripAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!manTripAllowed) return;
                          setIsManualModalVisible(true);
                        }}
                      >
                        <Swap />
                        Start Trip Manually
                      </ButtonOutlined>
                    </Tooltip>
                  )}
                  {[3].includes(singleTrip?.STATUS) && (
                    <Tooltip title={!manTripAllowed ? "No permission" : ""}>
                      <ButtonOutlined
                        className="update_complete_btn"
                        style={{
                          cursor: manTripAllowed ? "pointer" : "not-allowed",
                        }}
                        onClick={() => {
                          if (!manTripAllowed) return;
                          setIsManualModalVisible(true);
                        }}
                      >
                        <UpdateCompleted />
                        Complete Trip Manually
                      </ButtonOutlined>
                    </Tooltip>
                  )}

                  <Tooltip title={!updateAllowed ? "No permission" : ""}>
                    <EditIcon
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed", marginLeft: "10px"
                      }}
                      onClick={() => {
                        if (!updateAllowed) return;
                        editUser(selectededittwo);
                      }}
                    />
                  </Tooltip>
                  <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                    <Aideleteicon
                      style={{
                        cursor: deleteAllowed ? "pointer" : "not-allowed",
                        marginLeft: "10px",
                      }}
                      onClick={(e) => {
                        if (!deleteAllowed) return;
                        e.stopPropagation();
                        setDeleteId(record?.TRIPID); // Set the ID of the consignment to delete
                        setIsDeleteModalVisible(true); // Show the delete confirmation modal
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </Col>
          )}
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16}>
          {window.innerWidth >= 321 && window.innerWidth <= 480 ? (
            <Row gutter={[2, 2]} className="div_container p-4">
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Driver Name</label>
                <p>{singleTrip?.DRIVERNAME || "-"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Vehicle</label>
                <p>
                  {singleTrip?.VehRegNo ? singleTrip?.VehRegNo : "--"} (
                  {singleTrip?.DRIVERNAME ? singleTrip?.DRIVERNAME : "--"})
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Consign</label>
                <p>
                  {singleTrip?.ConsignmentCount
                    ? singleTrip?.ConsignmentCount
                    : "0"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Completed Consignment</label>
                <p>
                  {singleTrip?.CompletedCount ?? 0}/
                  {singleTrip?.ConsignmentCount ?? 0}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Loading Cycle</label>
                <p>
                  {singleTrip?.LOADINGCYCLE != null
                    ? formatMinutesToHHMM(singleTrip.LOADINGCYCLE)
                    : "00:00"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Offloading Cycle</label>
                <p>
                  {singleTrip?.OFFLOADINGCYCLE != null
                    ? formatMinutesToHHMM(singleTrip.OFFLOADINGCYCLE)
                    : "00:00"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>ODO Kms</label>
                <p>{singleTrip?.gpskms ? singleTrip?.gpskms : "--"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Trip Time</label>
                <p>
                  {singleTrip?.AvgTripTime != null
                    ? formatMinutesToHHMM(singleTrip.AvgTripTime)
                    : "00:00"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Consignor</label>
                <p>{singleTrip?.CUSTNAME || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Trip Type</label>
                <p>
                  {singleTrip?.Triptype === 2
                    ? userInfo?.MCID === 72
                      ? "Transit"
                      : "Safari"
                    : singleTrip?.Triptype === 1
                      ? "Local"
                      : singleTrip?.Triptype}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Break Time</label>
                <p>{singleTrip?.BreakMinutes || "---"} </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Carbon Footprint</label>
                <p>
                  {singleTrip?.CarbonFootprint
                    ? singleTrip?.CarbonFootprint
                    : "0"}{" "}
                  KgCo2
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Charge Type</label>
                <p>
                  {chargetype.find(
                    (item) => item.value === singleTrip?.CHARGETYPE,
                  )?.name || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Transporter</label>
                <p>{singleTrip?.SHIPPERNAME || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Dispatch Type</label>
                <p>
                  {DispatchType.find(
                    (item) => item.value === singleTrip?.DispatchType?.[0],
                  )?.name || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Shipment Type</label>
                <p>
                  {shipmentType.find(
                    (item) => item.value === singleTrip?.ShipmentType,
                  )?.name || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Device</label>
                <p>{singleTrip?.DeviceName || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Finish Type</label>
                <p>
                  {FinishType.find(
                    (item) => item.value === singleTrip?.FinishedType,
                  )?.name || "---"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Route</label>
                <p>{singleTrip?.RouteName || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Delivery Note Number</label>
                <p>{singleTrip?.FWayBill || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Container No</label>
                <p>{singleTrip?.ContainerNo || "---"}</p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Reference No</label>
                <p>{singleTrip?.ReferenceNo || "---"}</p>
              </Col>
              <Col></Col>
              <Col></Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Remarks</label>
                <p>{singleTrip?.REMARKS ? singleTrip?.REMARKS : "--"}</p>
              </Col>
              <Col></Col>
              <Col></Col>
              <Col></Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Fuel Quantity</label>
                <p>
                  {singleTrip?.FuelQuantity ? singleTrip?.FuelQuantity : "0"}
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={8} className="mb-4">
                <label>Trip Allowance</label>
                <p>
                  {singleTrip?.TripAllowance ? singleTrip?.TripAllowance : "0"}
                </p>{" "}
              </Col>
            </Row>
          ) : (
            <Col xs={24} xl={24}>
              <div className="container_for_consignorpage">
                <div className="consignor_code">
                  <label>Driver Name</label>
                  <p>{singleTrip?.DRIVERNAME || "-"}</p>
                </div>
                <div className="consignor_code">
                  <label>Vehicle</label>
                  <p>
                    {singleTrip?.VehRegNo ? singleTrip?.VehRegNo : "--"} (
                    {singleTrip?.DRIVERNAME ? singleTrip?.DRIVERNAME : "--"})
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Consign</label>
                  <p>
                    {singleTrip?.ConsignmentCount
                      ? singleTrip?.ConsignmentCount
                      : "0"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Completed Consignment</label>
                  <p>
                    {singleTrip?.CompletedCount ?? 0}/
                    {singleTrip?.ConsignmentCount ?? 0}
                  </p>
                </div>

                <div className="consignor_code">
                  <label>Loading Cycle</label>
                  <p>
                    {singleTrip?.LOADINGCYCLE != null
                      ? formatMinutesToHHMM(singleTrip.LOADINGCYCLE)
                      : "00:00"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Offloading Cycle</label>
                  <p>
                    {singleTrip?.OFFLOADINGCYCLE != null
                      ? formatMinutesToHHMM(singleTrip.OFFLOADINGCYCLE)
                      : "00:00"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>ODO Kms</label>
                  <p>{singleTrip?.gpskms ? singleTrip?.gpskms : "--"}</p>
                </div>
                <div className="consignor_code">
                  <label>Trip Time</label>
                  <p>
                    {singleTrip?.AvgTripTime != null
                      ? formatMinutesToHHMM(singleTrip.AvgTripTime)
                      : "00:00"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Consignor</label>
                  <p>{singleTrip?.CUSTNAME || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Trip Type</label>
                  <p>
                    {singleTrip?.Triptype === 2
                      ? userInfo?.MCID === 72
                        ? "Transit"
                        : "Safari"
                      : singleTrip?.Triptype === 1
                        ? "Local"
                        : singleTrip?.Triptype}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Break Time</label>
                  <p>
                    {singleTrip?.BreakMinutes
                      ? null
                      : singleTrip?.BreakMinutes === null
                        ? "--"
                        : 0}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Carbon Footprint</label>
                  <p>
                    {singleTrip?.CarbonFootprint
                      ? singleTrip?.CarbonFootprint
                      : "0"}{" "}
                    KgCo2
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Charge Type</label>
                  <p>
                    {chargetype.find(
                      (item) => item.value === singleTrip?.CHARGETYPE,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Transporter</label>
                  <p>{singleTrip?.SHIPPERNAME || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Dispatch Type</label>
                  <p>
                    {DispatchType.find(
                      (item) => item.value === singleTrip?.DispatchType?.[0],
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Shipment Type</label>
                  <p>
                    {shipmentType.find(
                      (item) => item.value === singleTrip?.ShipmentType,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Device</label>
                  <p>{singleTrip?.DeviceName || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Finish Type</label>
                  <p>
                    {FinishType.find(
                      (item) => item.value === singleTrip?.FinishedType,
                    )?.name || "---"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Route</label>
                  <p>{singleTrip?.RouteName || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Delivery Note Number</label>
                  <p>{singleTrip?.FWayBill || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Container No</label>
                  <p>{singleTrip?.ContainerNo || "---"}</p>
                </div>
                <div className="consignor_code">
                  <label>Reference No</label>
                  <p>{singleTrip?.ReferenceNo || "---"}</p>
                </div>
                <div className="consignor_code"></div>
                <div className="consignor_code"></div>
                <div className="consignor_code">
                  <label>Remarks</label>
                  <p>{singleTrip?.REMARKS ? singleTrip?.REMARKS : "--"}</p>
                </div>
                <div className="consignor_code"></div>
                <div className="consignor_code"></div>
                <div className="consignor_code"></div>
                <div className="consignor_code">
                  <label>Fuel Quantity</label>
                  <p>
                    {singleTrip?.FuelQuantity ? singleTrip?.FuelQuantity : "0"}
                  </p>
                </div>
                <div className="consignor_code">
                  <label>Trip Allowance</label>
                  <p>
                    {singleTrip?.TripAllowance
                      ? singleTrip?.TripAllowance
                      : "0"}
                  </p>
                </div>
                {Array.isArray(CustomData) &&
                  CustomData.length > 0 &&
                  CustomData.map((field) => (
                    <div className="consignor_code" key={field.CFID}>
                      <label>{field.FIELDNAME}</label>
                      <p>{field.VALUE || "-"}</p>
                    </div>
                  ))}
              </div>
            </Col>
          )}
        </Row>
      </WrapperBox>
      {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
        <WrapperBox>
          <Row>
            <Col xl={24} xs={24}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <ButtonWhite
                  style={{
                    height: 30,
                    minWidth: 195,
                    minHeight: 0,
                    backgroundColor: "#d0f0c0", // light green
                    color: "#000",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "15px"
                        : "0px",
                    width:
                      window.innerWidth >= 320 && window.innerWidth <= 374
                        ? "190px"
                        : "auto",
                  }}
                >
                  <div className="containerfour">
                    {dropdownselectchange === "1" ? (
                      <>
                        <div>Consignment</div>{" "}
                      </>
                    ) : null || dropdownselectchange === "2" ? (
                      <>
                        <div>Map</div>
                      </>
                    ) : null || dropdownselectchange === "3" ? (
                      <>
                        <div>Event</div>
                      </>
                    ) : null || dropdownselectchange === "4" ? (
                      <>
                        <div>Files</div>
                      </>
                    ) : null || dropdownselectchange === "5" ? (
                      <>
                        <div>Comment </div>
                      </>
                    ) : null || dropdownselectchange === "6" ? (
                      <>
                        <div>Driver Break </div>
                      </>
                    ) : null}
                  </div>
                </ButtonWhite>
              </Dropdown>
              <div className="container_five">
                {dropdownselectchange === "4" && (
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AITRIP",
                              refId: tripId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AITRIP",
                              refId: tripId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    {/* <Tooltip title={!uplFilesAllowed ? "No permission" : ""}> */}
                    <ButtonFilled
                      // style={{
                      //   cursor: uplFilesAllowed ? "pointer" : "not-allowed",
                      // }}
                      // disabled={!uplFilesAllowed}
                      className="upload-style1"
                      style={{ cursor: "pointer" }}
                    >
                      + Add
                    </ButtonFilled>
                    {/* </Tooltip>{" "} */}
                  </Upload>
                )}
                {dropdownselectchange === "1" && (
                  <StyledTable
                    dataSource={consignmentList}
                    pagination={false}
                    columns={columns1}
                    // onRow={(record, index) => ({
                    //   onMouseEnter: () => {
                    //     handlemouseenter(record?.key);
                    //   },
                    //   onMouseLeave: () => {
                    //     handlemouseleave();

                    //   },
                    // })}
                    onRow={(record, index, e) => {
                      return {
                        onMouseEnter: () => {
                          handlemouseenter(record?.key);
                        },
                        onMouseLeave: () => {
                          handlemouseleave();
                        },
                      };
                    }}
                  />
                )}
                {dropdownselectchange === "2" && (
                  <MapComponent
                    routePoints={startEndLoc}
                    locationsTL={locationData}
                  />
                )}
                {dropdownselectchange === "3" && (
                  <StyledTable
                    dataSource={filteredEventList}
                    pagination={false}
                    columns={columns3}
                  />
                )}

                {dropdownselectchange === "4" && (
                  <Spin spinning={loading}>
                    <FilesTable
                      filesList={filesList}
                      getFileData={getFileData}
                    />
                  </Spin>
                )}
                {dropdownselectchange === "5" && (
                  <ChatComponent
                    data={commentsList}
                    user={user}
                    getData={getCommentData}
                    id={tripId}
                    RefTab="TRIP"
                    setLoading={setLoading}
                  />
                )}

                {dropdownselectchange === "6" && (
                  <StyledTable
                    dataSource={breakList}
                    pagination={false}
                    columns={columns6}
                  />
                )}
              </div>
            </Col>
          </Row>
        </WrapperBox>
      ) : null}

      {window.innerWidth >= 320 && window.innerWidth <= 480 ? null : (
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div
                style={{ marginTop: "12px" }}
                className="tabsectionfor_table"
              >
                <Tabs
                  className="consignor_tab_container"
                  onChange={handlechange}
                  type="card"
                  items={[
                    {
                      label: "Consignment",
                      key: "1",
                    },
                    {
                      label: "Map",
                      key: "2",
                    },
                    {
                      label: "Event",
                      key: "3",
                    },
                    {
                      label: "Files",
                      key: "4",
                    },
                    {
                      label: "Comment",
                      key: "5",
                    },
                    {
                      label: "Driver Break",
                      key: "6",
                    },
                  ]}
                />
                {activekey === "4" && (
                  <Upload
                    customRequest={({ file, onSuccess }) => {
                      // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AITRIP",
                              refId: tripId,
                              lat: String(latitude), // <-- Real-time latitude
                              lng: String(longitude), // <-- Real-time longitude
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                              // BASE: base64Data,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "AITRIP",
                              refId: tripId,
                              lat: "", // fallback
                              lng: "", // fallback
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        },
                      );
                    }}
                    showUploadList={false}
                  >
                    <ButtonFilled className="upload-style1">+ Add</ButtonFilled>
                  </Upload>
                )}
              </div>
            </Col>
          </Row>

          {activekey === "1" && (
            <StyledTable
              dataSource={consignmentList}
              pagination={false}
              columns={columns1}
              // onRow={(record, index) => ({
              //   onMouseEnter: () => {
              //     handlemouseenter(record?.key);
              //   },
              //   onMouseLeave: () => {
              //     handlemouseleave();

              //   },
              // })}
              onRow={(record, index, e) => {
                return {
                  onMouseEnter: () => {
                    handlemouseenter(record?.key);
                  },
                  onMouseLeave: () => {
                    handlemouseleave();
                  },
                };
              }}
            />
          )}
          {activekey === "2" && (
            <MapComponent
              routePoints={startEndLoc}
              locationsTL={locationData}
            />
          )}
          {activekey === "3" && (
            <StyledTable
              dataSource={filteredEventList}
              pagination={false}
              columns={columns3}
            />
          )}
          {activekey === "4" && (
            <Spin spinning={loading}>
              <FilesTable filesList={filesList} getFileData={getFileData} />
            </Spin>
          )}
          {activekey === "5" && (
            <ChatComponent
              data={commentsList}
              user={user}
              getData={getCommentData}
              id={tripId}
              RefTab="TRIP"
              setLoading={setLoading}
            />
          )}
          {activekey === "6" && (
            <StyledTable
              dataSource={breakList}
              pagination={false}
              columns={columns6}
            />
          )}
        </WrapperBox>
      )}
      <Modal
        title="Updating ODO Reading"
        visible={isModalOpeN}
        onCancel={() => {
          setIsModalOpeN(false);
          form.resetFields();
          setEventData({});
        }}
        footer={[
          <Buttontransparent
            key="cancel"
            onClick={() => {
              setIsModalOpeN(false);
              form.resetFields();
              setEventData({});
            }}
            style={{ background: "#E6F4EA", color: "#1677FF" }}
          >
            Cancel
          </Buttontransparent>,
          <ButtonFilled
            key="submit"
            type="primary"
            onClick={() => form.submit()}
            style={{ background: "#008000" }}
            loading={loading}
          >
            Update
          </ButtonFilled>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={eventData}
        >
          <Row gutter={16}>
            {getFieldsForEvent(eventData?.EVTYPE)?.includes("odo") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="odo"
                  label="ODO Reading"
                  rules={[
                    { required: true, message: "Please enter ODO Reading" },
                  ]}
                >
                  <InputNumber
                    min={1}
                    style={{ width: "100%" }}
                    onKeyDown={(e) => {
                      const value = /^[0-9]$/.test(e.key);
                      if (!value && e.key !== "Backspace") {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("datetime") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="datetime"
                  label="Date & Time"
                  rules={[{ required: true, message: "Please select a Date" }]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            )}

            {getFieldsForEvent(eventData?.EVTYPE)?.includes("location") && (
              <Col sm={24} md={12}>
                <Form.Item
                  name="location"
                  label="Location"
                  rules={[
                    { required: true, message: "Please select the location" },
                  ]}
                >
                  <Input
                    readOnly
                    placeholder="Select a location"
                    onClick={() => setIsLocationPickerVisible(true)}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
      </Modal>
      <LocationPicker
        visible={isLocationPickerVisible}
        onClose={() => setIsLocationPickerVisible(false)} // Close the modal
        onSelect={handleLocationSelect} // Handle the selected location
      />
      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            <ButtonFilled key="create" type="primary" onClick={handleupdateee}>
              Update
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>Modifying Consignment</p>

                <span>
                  <CloseOutlined onClick={handleClose} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer>
    </>
  );
};

export default TripDetailsAI;
